import React, { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import {
  getByIdItemCategory,
  updateItemCategory,
} from "store/item-category/item-category-action"
import { getAllCommodityClassifications } from "store/general-renders/general-action"
import ItemCategoryForm from "components/ItemCategory/form"
import { itemCategoryAction } from "store/item-category/item-category-slice"
import Preloader from "components/Common/Loader"

const EditItemCategory = () => {
  document.title = "Edit Item Category"

  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading, itemCategory, error } = useSelector(
    state => state.itemCategory
  )
  const commodityClassifications = useSelector(
    state => state.generalRenders.commodityClassifications
  )
  const commodityClassificationLoading = useSelector(
    state => state.generalRenders.commodityClassificationLoading
  )

  //  onSubmit: Triggered when the form is submitted for updating the Item Category
  const onSubmit = values => {
    const form = new FormData()
    form.append("name", values.name)
    form.append("commodity_classification_id", values.commodity_classification_id)
    form.append("id", id)
    dispatch(updateItemCategory(id, form, navigate))
  }

  // fetch item category by id
  useEffect(() => {
    dispatch(getByIdItemCategory(id))
    dispatch(getAllCommodityClassifications())

    return () => {
      dispatch(itemCategoryAction.resetState())
    }
  }, [])

  return (
    <React.Fragment>
      {itemCategory ? (
        <ItemCategoryForm
          loading={loading}
          itemCategory={itemCategory?.data}
          error={error}
          onSubmit={onSubmit}
          formMode={"Edit"}
          commodityClassifications={commodityClassifications}
          commodityClassificationLoading={commodityClassificationLoading}
        />
      ) : (
        <Preloader loading={true} />
      )}
    </React.Fragment>
  )
}

export default EditItemCategory
